var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Verifizieren")]),_c('p',[_vm._v("Bitte bestätigen Sie den Link in der E-Mail.")])])}]

export { render, staticRenderFns }